import React from 'react'

const TimeOff = () => {
  return (
    <div>
      <p>Time off</p>
    </div>
  )
}

export default TimeOff
